/**
 * Describes the shape of a single action.
 */
export interface IAddOnsStateAction {
    type: ActionType;
    value?: any;
}

/**
 * Represents all of the actions that a user can perform on the search page. It's a class so that a dev can extend it.
 */
export class ActionType {
        
    static get BrowserNavigated() {
        return "BrowserNavigated";
    }
    
    static get LoadProductions() {
        return "LoadProductions";
    }
   
    static get UpdateProductionProcessing() {
        return "UpdateProductionProcessing";
    }

    static get AddPerformanceToRequest() {
        return "AddPerformanceToRequest";
    }
    static get RemoveAllPerformanceFromRequest() {
        return "RemoveAllPerformanceFromRequest";
    }
    static get RemovePerformanceFromRequest() {
        return "RemovePerformanceFromRequest";
    }

    static get PerformanceUnAvailable() {
        return "PerformanceUnAvailable";
    }
    static get DisplayLoading() {
        return "DisplayLoading";
    }
    static get FailedReserve() {
        return "ReserveFail";
    }
    static get UpdatePriceTypeToRequest() {
        return "UpdatePriceTypeToRequest";
    }
    
    static get UpdateTotal() {
        return "UpdateTotal";
    }

    static get UpdateZoneToRequest() {
        return "UpdateZoneToRequest";
    }

    static get TogglePerformancePanel() {
        return "TogglePerformancePanel";
    }
    static get RecievePerformanceDetails() {
        return "RecievePerformanceDetails";
    }

    static get UpdateProductionProcessingErrors() {
        return "UpdateProductionProcessingErrors";
    }

    static get UpdateSettings() {
        return "UpdateSettings";
    }
}